var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatarContact(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.44384 29.084C8.45984 29.084 7.52784 28.8667 6.6905 28.4787L2.6665 29.3333L3.50784 25.3013C3.11717 24.4613 2.8985 23.5253 2.8985 22.5387C2.8985 18.928 5.82517 16 9.43717 16C13.0492 16 15.9758 18.928 15.9758 22.5387C15.9758 26.1493 13.0478 29.0773 9.43717 29.0773",
    stroke: "#CE4100",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.816 16.0253C8.292 14.8853 8 13.636 8 12.32C8 6.96396 12.7973 2.66663 18.6667 2.66663C24.536 2.66663 29.3333 6.96396 29.3333 12.32C29.3333 15.4853 27.6507 18.272 25.068 20.0293C25.0693 21.0373 25.0667 22.396 25.0667 23.8226L20.8813 21.7613C20.1653 21.8986 19.4253 21.9733 18.6667 21.9733C17.7187 21.9733 16.8027 21.8506 15.9253 21.64",
    stroke: "#CE4100",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.39398 22.6195C6.42002 22.6456 6.42002 22.6878 6.39398 22.7138C6.36795 22.7398 6.32574 22.7398 6.2997 22.7138C6.27367 22.6878 6.27367 22.6456 6.2997 22.6195C6.32574 22.5935 6.36795 22.5935 6.39398 22.6195",
    stroke: "#CE4100",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39398 22.6195C9.42002 22.6456 9.42002 22.6878 9.39398 22.7138C9.36795 22.7398 9.32574 22.7398 9.2997 22.7138C9.27367 22.6878 9.27367 22.6456 9.2997 22.6195C9.32574 22.5935 9.36795 22.5935 9.39398 22.6195",
    stroke: "#CE4100",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.394 22.6195C12.42 22.6456 12.42 22.6878 12.394 22.7138C12.3679 22.7398 12.3257 22.7398 12.2997 22.7138C12.2737 22.6878 12.2737 22.6456 12.2997 22.6195C12.3257 22.5935 12.3679 22.5935 12.394 22.6195",
    stroke: "#CE4100",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6668 13.392C18.6668 12.516 19.2082 12.0414 19.7508 11.676C20.2815 11.3187 20.8122 10.8534 20.8122 9.99604C20.8122 8.81071 19.8522 7.85071 18.6668 7.85071C17.4815 7.85071 16.5215 8.81071 16.5215 9.99604",
    stroke: "#CE4100",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 16.6107C18.5933 16.6107 18.5333 16.6707 18.5333 16.7441C18.5333 16.8174 18.5933 16.8774 18.6667 16.8774C18.74 16.8774 18.8 16.8174 18.8 16.7441C18.8 16.6707 18.74 16.6107 18.6667 16.6107",
    stroke: "#CE4100",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarContact);
export default __webpack_public_path__ + "static/media/avatar_contact.92a9116ad543557906bf12379c8f8bad.svg";
export { ForwardRef as ReactComponent };